import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _defineProperty from '/app/node_modules/babel-runtime/helpers/defineProperty';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import { passwordErrorMessageMixin } from '~/mixins';
import { passwordComplexity } from '~/validators';

export default {
    layout: 'login',
    mixins: [passwordErrorMessageMixin],
    fetch: function fetch(_ref) {
        var store = _ref.store,
            app = _ref.app,
            query = _ref.query;

        store.commit('dashboard/details/setToolbarTitle', 'Reestablecer contraseña');
    },
    asyncData: function asyncData(_ref2) {
        var store = _ref2.store,
            query = _ref2.query,
            redirect = _ref2.redirect,
            app = _ref2.app;

        var _ref3 = query || {},
            q = _ref3.q;

        if (!q) return redirect('/');

        var decoded = Buffer.from(q.substring(1), 'base64').toString('ascii').split('|');

        if (decoded.length !== 2 || app.$moment.utc(decoded[2], 'YYYYMMDDHHmmss').clone().add(1, 'day').isBefore(app.$moment.utc())) return redirect('/?linkExpired=true');
        return { email: decoded[0], code: decoded[1] };
    },
    data: function data() {
        var _ref4;

        return _ref4 = {
            sending: false,
            password: null,
            confirmPassword: null,
            errorMessage: null,
            messageChangePassword: false,
            loader: null,
            loading: false
        }, _defineProperty(_ref4, 'errorMessage', 'Contraseñas no coinciden'), _defineProperty(_ref4, 'isLoginError', false), _defineProperty(_ref4, 'passwordOne', ''), _defineProperty(_ref4, 'passwordTwo', ''), _ref4;
    },

    validations: {
        password: {
            required: required,
            minLength: minLength(8),
            passwordComplexity: passwordComplexity
        },
        confirmPassword: {
            sameAs: sameAs('password'),
            minLength: minLength(8),
            passwordComplexity: passwordComplexity
        }
    },
    computed: {
        passwordErrorMessages: function passwordErrorMessages() {
            var propertyName = 'password';
            return [!this.$v[propertyName].$dirty || this.$v[propertyName].required || 'Debes ingresar una contrase\xF1a', !this.$v[propertyName].$dirty || this.$v[propertyName].passwordComplexity || 'La contrase\xF1a tiene que tener al menos 1 may\xFAscula, al menos 1 min\xFAscula, al menos 1 n\xFAmero y al menos un simbolo', !this.$v[propertyName].$dirty || this.$v[propertyName].minLength || 'Debes ingresar al menos ' + this.$v[propertyName].$params.minLength.min + ' y m\xE1ximo ' + this.maxCharacters + ' caract\xE9res'].filter(function (val) {
                return typeof val === 'string';
            });
        },
        confirmPasswordErrorMessages: function confirmPasswordErrorMessages() {
            var propertyName = 'confirmPassword';
            return [!this.$v[propertyName].$dirty || this.$v[propertyName].passwordComplexity || 'La contrase\xF1a tiene que tener al menos 1 may\xFAscula, al menos 1 min\xFAscula, al menos 1 n\xFAmero y al menos un simbolo', !this.$v[propertyName].$dirty || this.$v[propertyName].sameAs || 'La contrase\xF1a tiene que ser identica', !this.$v[propertyName].$dirty || this.$v[propertyName].minLength || 'Debes ingresar al menos ' + this.$v[propertyName].$params.minLength.min + ' y m\xE1ximo ' + this.maxCharacters + ' caract\xE9res'].filter(function (val) {
                return typeof val === 'string';
            });
        }
    },
    methods: {
        sendPassword: function sendPassword() {
            this.$router.push('/send-password');
        },
        onSubmit: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$v.$touch();

                                if (!this.$v.$invalid) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:

                                this.sending = true;
                                this.errorMessage = null;

                                this.loading = true;

                                _context.prev = 6;
                                _context.next = 9;
                                return this.$store.dispatch('user/updatePassword', {
                                    email: this.email,
                                    afterPassword: this.password,
                                    beforePassword: this.confirmPassword
                                });

                            case 9:
                                this.loading = false;
                                this.loader = null;
                                this.isLoginError = true;
                                this.messageChangePassword = true;
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](6);

                                this.$controlMessage(_context.t0);

                            case 18:
                                this.sending = false;
                                this.sendingText = 'Aceptar';

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 15]]);
            }));

            function onSubmit() {
                return _ref5.apply(this, arguments);
            }

            return onSubmit;
        }()
    },
    watch: {
        password: function password(val) {
            this.isLoginError = false;
            this.passwordOne = val;
        },
        confirmPassword: function confirmPassword(val) {
            this.isLoginError = true;
            this.passwordTwo = val;
            if (this.passwordOne === this.passwordTwo) {
                return this.isLoginError = false;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/restore-password.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/restore-password.vue
// module chunks = 14